﻿//==========================================================================================================
// Copyright (C) Nore Technology AB. All Rights Reserved.
//==========================================================================================================

//-------------------------------------------------------------------------------------
// Imports
//-------------------------------------------------------------------------------------

import { JssClass } from "~base/Styling";
import { getSize } from "~base/Components/Layout/JssSpacing";
import { UserInfoCustomizations } from "~base/Pages/Shared/UserInfoCard";
import { RegisterPageStyles } from "./Styles";

//-------------------------------------------------------------------------------------
// Customizations
//-------------------------------------------------------------------------------------

export interface RegisterPageCustomizations {
    showEmail: boolean;
    showPhoneNumber: boolean;
    showVerksamhetsort: boolean;
    verksamhetsortObligatory: boolean;
    phoneObligatory: boolean;
    emailObligatory: boolean;
    showRådgivarkod: boolean;
    validateRådgivarkod: (rådgivarKod: string) => boolean;
    showArbetarMedDistansrådgivning: boolean;
    allowMultipleAdvisorCodes: boolean;
    customStyles?: RegisterPageStyles;
    userInfoCustomization?: UserInfoCustomizations;
    languageFilterFunction?: (languages: string[]) => string[];
}

export const defaultStyling = {
    header: {
        padding: `25px ${25 + getSize("HalfMedium")}px 0px ${25 + getSize("HalfMedium")}px`,
    },
    gridAlignment: {
        alignItems: "flex-end",
    },
    radioPadding: {
        marginBottom: "32px",
        marginLeft: "3px",
        justifySelf: "center",
    },
};

const validateRådgivarkod: (rådgivarKod: string) => boolean = (
    rådgivarKod: string
) => {
    return true;
};

const filterFunc: (languages: string[]) => string[] = (languages: string[]) => {
    return languages;
};

export const RegisterPageDefaultCustomization = {
    showEmail: true,
    showPhoneNumber: true,
    showVerksamhetsort: false,
    verksamhetsortObligatory: false,
    phoneObligatory: false,
    emailObligatory: false,
    showRådgivarkod: false,
    validateRådgivarkod: validateRådgivarkod,
    showArbetarMedDistansrådgivning: false,
    allowMultipleAdvisorCodes: false,
    customStyles: defaultStyling,
    languageFilterFunction: filterFunc,
} as RegisterPageCustomizations;
